import {iosShareSvg as Icon__small__iosShareSvg} from '../Icon__small/Icon__small--iosShare.js'

export var iosShare = {
  name: 'iosShare',
  category: 'icon',
  colorable: true,
  svg: Icon__small__iosShareSvg,
};
